import { FC, useState } from "react";
import "./style.scss";
import Button from "../Button";
import { Button_Style, Button_Type } from "../Button/Button";
import { ReactComponent as IconPassword } from "assets/img/icons/icon_Password.svg";
import { ReactComponent as IconHidePassword } from "assets/img/icons/icon_HidePassword.svg";

type InputProps = {
    value?: string;
    onChange?: (e: any) => void;
    placeholder: string;
    required?: boolean;
    className?: string;
    errorMessage?: string;
    rightIcon?: React.ReactNode;
    inputRef?: React.Ref<HTMLInputElement>;
    type?: string;
} & Record<string, any>;

const Input: FC<InputProps> = ({
    value,
    onChange,
    placeholder,
    required,
    className = "",
    errorMessage,
    rightIcon,
    inputRef,
    type = "text",
    ...rest
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === "password";
    const inputType = isPassword ? (showPassword ? "text" : "password") : type;

    return (
        <div className={`input-box ${className} ${errorMessage ? "error" : ""}`}>
            <input
                value={value}
                onChange={onChange}
                required={required}
                {...rest}
                type={inputType}
                placeholder=""
                ref={inputRef}
            />
            <label>{placeholder}</label>
            {(isPassword || rightIcon) && (
                <div className="input-icon">
                    {isPassword && (
                        <Button
                            isIconButton
                            buttonType="button"
                            icon={showPassword ? <IconHidePassword /> : <IconPassword />}
                            className="icon_button_edit"
                            style={Button_Style.OUTLINED}
                            title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                            onClick={() => setShowPassword((v) => !v)}
                        />
                    )}
                    {rightIcon}
                </div>
            )}
            {errorMessage && <span className="error-message-input">{errorMessage}</span>}
            <span className="divider"></span>
        </div>
    );
};

export default Input;
